import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './List.css';

function List() {
  const { type } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`https://srlisto-spa.mmeip.com:8002/api/${type}`)
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, [type]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="list">
      <h2 className="list-title">{type.toUpperCase()}</h2>
      <ul className="list-items">
        {data.map((item, index) => (
          <li key={index} className="list-item">{item.name}</li>
        ))}
      </ul>
    </div>
  );
}

export default List;

